var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountingSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9594 2.5C14.404 3.39443 11.1392 5 7 5C2.86077 5 -0.404012 3.39443 0.0406011 2.5C0.537691 1.5 2.5261 0 7 0C11.4739 0 13.4623 1.5 13.9594 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6V4C0 4 2.5 6 7 6C11.5 6 14 4 14 4V6C14 6 11.5 8 7 8C2.5 8 0 6 0 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12V10C0 10 2.5 12 7 12C11.5 12 14 10 14 10V11.5C14 11.5 12.1003 11.9129 11 12.5C10.0211 13.0223 9.29728 13.8106 9.29728 13.8106C8.84107 13.8682 7.71763 14 7 14C2.5 14 0 12 0 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.9502V7C0 7 2.5 8.9502 7 8.9502C11.5 8.9502 14 7 14 7V8.9502C14 8.9502 11.5 10.9502 7 10.9502C2.5 10.9502 0 8.9502 0 8.9502Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9594 14.5C24.404 15.3944 21.1392 17 17 17C12.8608 17 9.59599 15.3944 10.0406 14.5C10.5377 13.5 12.5261 12 17 12C21.4739 12 23.4623 13.5 23.9594 14.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18V16C10 16 12.5 18 17 18C21.5 18 24 16 24 16V18C24 18 21.5 20 17 20C12.5 20 10 18 10 18Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.9502V19C10 19 12.5 20.9502 17 20.9502C21.5 20.9502 24 19 24 19V20.9502C24 20.9502 21.5 22.9502 17 22.9502C12.5 22.9502 10 20.9502 10 20.9502Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9502V13C0 13 2.5 14.9502 7 14.9502C7.63883 14.9502 8.23736 14.9109 8.79414 14.8434V16.8407C8.23736 16.9099 7.63883 16.9502 7 16.9502C2.5 16.9502 0 14.9502 0 14.9502Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9502V16C0 16 2.5 17.9502 7 17.9502C7.63883 17.9502 8.23736 17.9109 8.79414 17.8434V19.8407C8.23736 19.9099 7.63883 19.9502 7 19.9502C2.5 19.9502 0 17.9502 0 17.9502Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingSelected);
export default __webpack_public_path__ + "static/media/accounting-selected.4f5a12c62088c1ed0e9423778167d1c5.svg";
export { ForwardRef as ReactComponent };